<template>
    <div>
        <b-modal :id="modalId" :title="modalTitle" size="xl" no-close-on-backdrop
            no-close-on-esc hide-footer @show="init()">
            <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
            <div v-else>
                <b-row class="mt-3">
                    <b-col md="6">
                        <div>
                            <div class="font-weight-bold">Jenis Barang</div>
                            <div id="jenis-barang">
                                <multiselect v-model="input.kind" :allow-empty="false" label="name" track-by="id"
                                    :internal-search="true" @input="fetchMerkBarang" placeholder="-- Pilih Salah Satu --"
                                    :options="kinds" />
                            </div>
                        </div>
                        <div>
                            <div class="font-weight-bold mt-3">Tipe Barang</div>
                            <div id="tipe-barang">
                                <multiselect :disabled="fetch || !input.brand" v-model="input.type" :allow-empty="false" label="name"
                                    track-by="id" :internal-search="true" placeholder="-- Pilih Salah Satu --" :options="types"
                                    />
                            </div>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="font-weight-bold">Merk Barang</div>
                            <div id="merk-barang">
                                <multiselect :disabled="fetch || !input.kind" v-model="input.brand" :allow-empty="false" label="name"
                                    track-by="id" :internal-search="true" @input="fetchTipeBarang"
                                    placeholder="-- Pilih Salah Satu --" :options="brands"/>
                            </div>
                    </b-col>
                    <b-col md="6" v-if="itemFlags.isPerhiasan">
                        <div>
                            <div class="font-weight-bold mt-3">Ada Cap</div>
                            <multiselect v-model="input.hasMark" label="name" :options="optBoolean" placeholder="-- Pilih Salah Satu --" />
                        </div>
                    </b-col>
                    <b-col md="6" v-if="itemFlags.isPerhiasan">
                        <div>
                            <div class="font-weight-bold mt-3">Tipe Emas</div>
                            <multiselect :disabled="fetch || !input.type" v-model="input.goldType" :allow-empty="false" label="name"
                                track-by="id" :internal-search="true" placeholder="-- Pilih Salah Satu --"
                                :options="goldTypes" />
                        </div>
                    </b-col>
                    <b-col md="6" class="mt-3">
                        <div>
                            <div class="font-weight-bold">Ada Kerusakan</div>
                            <multiselect v-model="input.isDamaged" label="name" :options="optBoolean" placeholder="-- Pilih Salah Satu --" />
                        </div>
                    </b-col>
                </b-row>
                <hr />

                <b-row class="mb-4" v-if="!itemFlags.isLMScan">
                    <b-col md="12">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Kadar" class="font-weight-bold">
                                    <b-form-input
                                        id="purity"
                                        v-model="input.purity"
                                        :disabled="isPurityDisabled"
                                    />
                                    <small v-if="isPurityDisabled" class="text-muted">Kadar pemurnian selalu 1000</small>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Berat Kotor" class="font-weight-bold">
                                    <b-input-group append="gr">
                                        <b-form-input
                                            id="dry-weight"
                                            v-model="input.dryWeight"
                                        />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Berat Potongan" class="font-weight-bold">
                                    <b-input-group append="gr">
                                        <b-form-input
                                            id="weight-reduction"
                                            v-model="input.weightReduction"
                                        />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <div class="mt-2" v-if="itemFlags.isPerhiasan">
                                    <div class="font-weight-bold">Merk Cap Emas</div>
                                    <multiselect
                                        :disabled="fetch || !input.type"
                                        v-model="input.goldMintMark"
                                        :allow-empty="false"
                                        label="name"
                                        track-by="id"
                                        :internal-search="true"
                                        placeholder="-- Pilih Salah Satu --"
                                        :options="goldMintMarks"
                                    />
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" v-if="!itemFlags.isLMRetro">
                                <b-form-group label="Jumlah Keping" class="font-weight-bold">
                                    <b-input-group append="pcs">
                                        <b-form-input
                                            id="piece-count"
                                            v-model="input.pieceCount"
                                        />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" v-if="itemFlags.isPerhiasan">
                                <b-form-group label="Cap Getok" class="font-weight-bold">
                                    <multiselect
                                        class="font-weight-normal"
                                        v-model="input.isStamped"
                                        label="name"
                                        :options="optBoolean"
                                        placeholder="-- Pilih Salah Satu --"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

                <b-row v-if="!itemFlags.isLMScan">
                    <b-col md="12">
                        <p class="font-weight-bold">
                            Berat Bersih: {{ netWeight }}
                        </p>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button id="submit-process" variant="success" :disabled="isSubmitting" @click="promptSubmit">
                            {{ isSubmitting ? "Memproses..." : submitButtonLabel }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe id="barcode-iframe" :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodeType == 'barcode' ? 'Mini' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button id="finish-approval" variant="primary" @click="finishApproval">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'modal-execute-process',
    props: {
        batchId: { type: Number, required: true },
        type: { type: Number, required: true }
    },
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            input: {
                kind: null,
                brand: null,
                type: null,
                purity: null,
                dryWeight: null,
                weightReduction: null,
                goldMintMark: null,
                goldType: null,
                pieceCount: 1,
                hasMark: null,
                isDamaged: null,
                isStamped: null
            },

            optBoolean: [
                { value: true, name: "Ada" },
                { value: false, name: "Tidak Ada" }
            ],
            kinds: [],
            brands: [],
            types: [],
            goldMintMarks: [],
            goldTypes: [],
            fetch: false,

            barcodeLink: null,
            barcodeLinkMini: null,
            barcodeType: 'barcode',
            barcodeToggleCooldown: false,
        };
    },
    computed: {
        isPurityDisabled() {
            return this.type === 2;
        },
        submitButtonLabel() {
            return this.type === 1 ? "Lebur" : "Murnikan";
        },
        modalTitle() {
            return this.type === 1 ? "Eksekusi Lebur" : "Eksekusi Pemurnian";
        },
        modalId() {
            return this.type === 1 ? "m-execute-melt" : "m-execute-refine";
        },
        itemFlags() {
            return {
                isLMRetro: this.input.kind && this.input.kind.id === 261,
                isLMScan: this.input.kind && this.input.kind.id === 251,
                isPerhiasan: this.input.kind && this.input.kind.id === 257,
            };
        },
        netWeight() {
            let dw = parseFloat(this.input.dryWeight || 0);
            let wr = parseFloat(this.input.weightReduction || 0);
            let nw = dw - wr;
            return (isNaN(nw) ? 0 : nw).toFixed(3) + " gr";
        }
    },
    methods: {
        async init() {
            this.initStatus = 0;
            this.clearInput();
            await Promise.all([
                this.fetchJenisBarang(),
                this.fetchGoldMintMark(),
                this.fetchGoldType()
            ]);
            this.initStatus = 1;
        },

        clearInput() {
            this.input = {
                kind: null,
                brand: null,
                type: null,
                purity: this.type === 2 ? 1000 : null,
                dryWeight: null,
                weightReduction: null,
                goldMintMark: null,
                goldType: null,
                pieceCount: 1,
                hasMark: null,
                isDamaged: null,
                isStamped: null
            };
            this.brands = [];
            this.types = [];
        },

        async fetchJenisBarang() {
            this.fetch = true;
            await this.$axios.get('master/kinds?category=EMAS').then((res) => {
                this.kinds = res.data.data;
            }).finally(() => {
                this.fetch = false;
            });
        },

        async fetchMerkBarang() {
            this.input.brand = null;
            this.input.type = null;
            this.input.purity = this.type === 2 ? 1000 : null;
            this.input.dryWeight = null;
            this.input.weightReduction = null;
            this.input.goldMintMark = null;
            this.input.goldType = null;
            this.input.pieceCount = 1;
            this.types = [];
            if (!this.input.kind) return;
            this.fetch = true;
            await this.$axios.get(`master/brands/${this.input.kind.id}`).then((res) => {
                this.brands = res.data.data;
            }).finally(() => {
                this.fetch = false;
            });
        },

        async fetchTipeBarang() {
            this.input.type = null;
            this.input.purity = this.type === 2 ? 1000 : null;
            this.input.dryWeight = null;
            this.input.weightReduction = null;
            this.input.goldMintMark = null;
            this.input.goldType = null;
            this.input.pieceCount = 1;
            if (!this.input.brand) return;
            this.fetch = true;
            await this.$axios.get(`master/types/${this.input.brand.id}`).then((res) => {
                this.types = res.data.data;
            }).finally(() => {
                this.fetch = false;
            });
        },

        async fetchGoldMintMark() {
            this.fetch = true;
            await this.$axios.get('master/gold-mint-mark').then((res) => {
                this.goldMintMarks = res.data.data;
            }).finally(() => {
                this.fetch = false;
            });
        },

        async fetchGoldType() {
            this.fetch = true;
            await this.$axios.get('master/gold-type').then((res) => {
                this.goldTypes = res.data.data;
            }).finally(() => {
                this.fetch = false;
            });
        },

        promptSubmit() {
            const isValidValue = val => val !== null && val !== '';

            const modes = {
                LMScan: [
                    { key: 'kind', msg: 'Jenis Barang tidak boleh kosong' },
                    { key: 'brand', msg: 'Merk Barang tidak boleh kosong' },
                    { key: 'type', msg: 'Tipe Barang tidak boleh kosong' },
                    { key: 'isDamaged', msg: 'Status Kerusakan harus dipilih' },
                ],
                LMRetro: [
                    { key: 'kind', msg: 'Jenis Barang tidak boleh kosong' },
                    { key: 'brand', msg: 'Merk Barang tidak boleh kosong' },
                    { key: 'type', msg: 'Tipe Barang tidak boleh kosong' },
                    { key: 'dryWeight', msg: 'Berat Kotor tidak boleh kosong' },
                    { key: 'weightReduction', msg: 'Berat Potongan tidak boleh kosong' },
                    { key: 'isDamaged', msg: 'Status Kerusakan harus dipilih' },
                ],
                Perhiasan: [
                    { key: 'kind', msg: 'Jenis Barang tidak boleh kosong' },
                    { key: 'brand', msg: 'Merk Barang tidak boleh kosong' },
                    { key: 'type', msg: 'Tipe Barang tidak boleh kosong' },
                    { key: 'hasMark', msg: 'Status Cap Tanda harus dipilih' },
                    { key: 'goldType', msg: 'Tipe Emas tidak boleh kosong' },
                    { key: 'dryWeight', msg: 'Berat Kotor tidak boleh kosong' },
                    { key: 'weightReduction', msg: 'Berat Potongan tidak boleh kosong' },
                    { key: 'goldMintMark', msg: 'Merk Cap Emas tidak boleh kosong' },
                    { key: 'pieceCount', msg: 'Jumlah Keping tidak boleh kosong' },
                    { key: 'isDamaged', msg: 'Status Kerusakan harus dipilih' },
                    { key: 'isStamped', msg: 'Cap Getok harus dipilih' },
                ],
            };

            let ruleSet = null;
            if (this.itemFlags.isLMScan) ruleSet = modes.LMScan;
            else if (this.itemFlags.isLMRetro) ruleSet = modes.LMRetro;
            else if (this.itemFlags.isPerhiasan) ruleSet = modes.Perhiasan;

            if (!ruleSet) {
                this.$helper.toastError(this, "Tipe Barang tidak valid");
                return;
            }

            for (const { key, msg } of ruleSet) {
                const val = this.input[key];
                if (!isValidValue(val)) {
                    this.$helper.toastError(this, msg);
                    return;
                }
            }

            if (this.type === 1 && isValidValue(this.input.purity) && (this.input.purity < 1 || this.input.purity > 1000)) {
                this.$helper.toastError(this, "Kadar harus berada di antara 1 dan 1000");
                return;
            }

            let actionLabel = this.type === 1 ? "melebur" : "memurnikan";
            let confirmed = confirm(`Apakah anda yakin ingin ${actionLabel} batch ini? Proses ini tidak dapat dibatalkan.`);
            if (!confirmed) return;

            this.execProcess();
        },

        execProcess() {
            const payload = {
                result_type_id: this.input.type ? this.input.type.id : null,
                result_purity: this.type === 1 && this.input.purity ? Number(this.input.purity) : null,
                result_dry_weight: this.input.dryWeight ? parseFloat(this.input.dryWeight) : null,
                result_weight_reduction: this.input.weightReduction ? parseFloat(this.input.weightReduction) : null,
                result_gold_mark_id: this.input.goldMintMark ? this.input.goldMintMark.id : null,
                result_gold_type_id: this.input.goldType ? this.input.goldType.id : null,
                result_piece_count: this.input.pieceCount ? Number(this.input.pieceCount) : 1,
                result_has_mark: this.input.hasMark ? this.input.hasMark.value : null,
                result_is_damaged: this.input.isDamaged ? this.input.isDamaged.value : null,
                result_is_stamped: this.input.isStamped ? this.input.isStamped.value : null
            };

            this.isSubmitting = true;
            this.$axios.post("gold-batches/" + this.batchId + "/process", payload)
                .then((res) => {
                    this.$bvModal.hide(this.modalId);
                    this.barcodeLink = res.data.data.link;
                    this.barcodeLinkMini = res.data.data.link_mini;
                    this.barcodeType = 'barcode';
                    this.$bvModal.show('m-barcode');
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        getBarcodeLink() {
            if (this.barcodeType == 'mini') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkMini}`;
            }
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`;
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true;
            if (this.barcodeType == 'barcode') this.barcodeType = 'mini';
            else this.barcodeType = 'barcode';
            setTimeout(function () {
                this.barcodeToggleCooldown = false;
            }.bind(this), 2000);
        },

        finishApproval() {
            this.$bvModal.hide('m-barcode');
            this.$emit("processed", "Batch berhasil diproses!");
        }
    }
};
</script>
